export class TarangireText {
  paragraphHeaders = [
    'Scenery',
    'Flora & Fauna',
    'Interesting Qualities',
    'Tarangire National Park Map'
  ];

  paragraphs = [
    ` <p class="generated-p">
                        Protect your bananas with your life! Naughty black-faced monkeys will stop at nothing to steal
                        snacks from your sack lunch!
                    </p>`,
    `<p class="generated-p">
                        Deep in Tarangire National Park, you will have the opportunity to enjoy a safari picnic (with
                        you and dozens of your monkey friends) all while seated above the imposing Tarangire River. This
                        river crosses through the entire park and is the epicenter for wildlife. Elephants, zebras,
                        wildebeest and flocks of birds gather here to enjoy the refreshing water.
                    </p>`,
    `<p class="generated-p">
                        Clocking in as Tanzania’s 6th largest park, we recommend spending at least a full day, if not 2
                        days, exploring the 2,850 square kilometers. Beyond the wildlife, Tarangire is famous for its
                        breathtaking landscapes. Baobab trees are plentiful here -- there are hundreds of opportunities
                        to observe these ancient trees, most of which are more than 1 thousand years old. Local mountain
                        porters used to live within the tree trunks, until the Tanzanian
                        Government converted the region into a national park.
                    </p>`,
    `<p class="generated-p">Tarangire National Park has a high variety of bird species, due to the lush vegetation at the park. Perhaps the most intriguing of these birds is the
        <a class="generated-a" href="https://en.wikipedia.org/wiki/Southern_ground_hornbill">Southern Ground Hornbill</a>. Due to its red color, it is sometimes referred to as the Devil bird
        by the locals. These will remind you of Turkeys as you see them trotting along. Another unique component of Tarangire National Park is its colossal termite mounds, which can reach over 12
        feet in height. Termites are prevalent in the park, and can cause entire Baobab trees to collapse over time.</p>`,
    `<p class="generated-p">
       Tarangire National Park is in the midst of a dry area of Tanzania, but vegetation and life flourish here! Due to the Tarangire River and the water it supplies, Tarangire National Park
         is lush with green, which is why you will see massive elephant herds here. On Kopa Tours safaris, you will visit the Tarangire often as your last safari day on the way back to Moshi from
         <a href="../../national-parks/ngorongoro" class="generated-a">Ngorongoro Crater Conservation Area</a>, but it is certainly not least!
         Here you will come closer than in any other park to the animals you crave to see.
       </p>`
  ];

  factsHeader = 'Tarangire Facts';
  facts = [
    'Baobab trees, common in Tarangire National Park, are truly unique. They are known to live for hundreds or some rumored even thousands of years!',
    `Elephant herds in Tarangire National Park are massive - some having even 300 or more Elephants!`,
    `A white giraffe was spotted in Tarangire National Park in 2015. The giraffe looks white due to a condition resulting in a loss of pigmentation.`,
    `The Tarangire River serves as a rare, reliable water source, drawing an immense concentration of animals.`
  ];
  badge = `<i><span class="badge badge-secondary px-2 py-1">Baobab Trees Here!</span></i>`;
}
